module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLight.4bd040d.woff";